import { Injectable } from '@angular/core';
import { SocketEvent } from '../models/socket-event';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket: Socket | undefined;
  private sessionId: number = Date.now();

  initializeSocketConnection(): void {
    // Initialize socket connection
    this.socket = io(environment.apiUrl); // Replace with your socket server URL
  }

  /**
   * not used jet - function for appInit (app.config + socket-initializer)
   */
  initializeSocketConnectionAppInit(): Observable<any> {
    return new Observable(observer => {
      // Establish the socket connection
      this.socket = io(environment.apiUrl);

      // Handle socket events or any other initialization logic here
      this.socket.on('connect', () => {
        observer.next();
        observer.complete();
      });
    });
  }

  emitEvent(name: string, event: SocketEvent): void {
    event.sessionId = this.sessionId;
    this.socket?.emit(name, event);
  }

  onEvent(event: string): Observable<any> {
    return new Observable<any>(observer => {
      this.socket?.on(event, (data: any) => {
        if (data.sessionId !== this.sessionId) observer.next(data);
      });
      // Cleanup function when the component or service is destroyed
      return () => {
        this.socket?.removeListener(event);
      };
    });
  }

  // Close the WebSocket connection when the service is destroyed
  closeConnection(): void {
    this.socket?.disconnect();
  }
}
